import {
  FiClipboard,
  FiHeart,
  FiShield,
  FiZap,
  FiRefreshCw,
  FiLayers,
  FiAlertTriangle,
  FiServer,
  FiLock,
  FiEye,
  FiCloud,
  FiUsers,
  FiSearch,
  FiAward,
  FiCoffee,
  FiCheckCircle,
  FiGlobe,
  FiTool,
  FiSun,
  FiFileText,
  FiShare2,
  FiBarChart2,
  FiHome,
  FiGitBranch,
  FiArrowRight,
  FiBookOpen,
  FiMail,
  FiFeather,
  FiBriefcase,
} from "react-icons/fi";

export const ICON_MAP = {
  clipboard: FiClipboard,
  heart: FiHeart,
  leaf: FiFeather,
  shield: FiShield,
  zap: FiZap,
  refresh: FiRefreshCw,
  building: FiBriefcase,
  layers: FiLayers,
  alert: FiAlertTriangle,
  server: FiServer,
  lock: FiLock,
  eye: FiEye,
  cloud: FiCloud,
  users: FiUsers,
  search: FiSearch,
  award: FiAward,
  coffee: FiCoffee,
  check: FiCheckCircle,
  globe: FiGlobe,
  tool: FiTool,
  sun: FiSun,
  file: FiFileText,
  share: FiShare2,
  bar: FiBarChart2,
  home: FiHome,
  git: FiGitBranch,
};

export const ArrowRightIcon = FiArrowRight;
export const BookOpenIcon = FiBookOpen;
export const MailIcon = FiMail;
export const AwardIcon = FiAward;
export const CheckIcon = FiCheckCircle;
